import { Box } from "grommet";
import { useCallback } from "react";
import Slider from "./slider";

export interface SlidersProps {
  showInsignificants: boolean;
  sliders: number[];
  handleSliderChange(value: number, index: number): any;
  isModelLoaded: boolean;
  significantDimensions: number[];
}

export function Sliders({
  showInsignificants,
  sliders,
  handleSliderChange,
  isModelLoaded,
  significantDimensions,
}: SlidersProps): React.ReactElement {
  // on mouse out of the sliders component, set the hovered slider to undefined
  const handleMouseOut = useCallback(() => {
    return;
  }, []);
  return (
    <Box direction="row" justify="evenly" width="100%" onMouseOut={() => handleMouseOut()}>
      {sliders.map((value: number, i: number) => (
        <Slider
          key={i}
          sliderNumber={i + 1}
          onSliderHover={() => {
            return;
          }}
          significant={significantDimensions.includes(i + 1)}
          value={value}
          min={-4}
          step={0.5}
          max={4}
          orientation="vertical"
          onChange={((event: any, newValue: any) => handleSliderChange(newValue as number, i)) as any}
          disabled={!isModelLoaded || (!showInsignificants && !significantDimensions.includes(i + 1))}
          valueLabelDisplay="off"
        />
      ))}
    </Box>
  );
}
